
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { AppModule, DeviceType } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Hamburger from '@/components/Hamburger/index.vue'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import {
  getDisplayName,
  getAvatar,
  getuserCurrentAppName,
  getuserCurrentApp
} from '@/utils/cookies.ts'
import { isDashboardTicketType } from '@/utils/commonFunc'
import { Route } from 'vue-router'

@Component({
  components: {
    Hamburger,
    Breadcrumb
  }
})
export default class extends Vue {
  @Prop({ default: true }) private showIcon!: boolean;
  private search = '';
  private dateFilter: string[] = [];
  private userCurrentAppName = '';
  private appEnv = '';
  // 日期过滤器
  expireTimeOption: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  };

  get isDashboardTicketType() {
    return isDashboardTicketType()
  }

  // 是否在知音楼APP内
  get isInYach() {
    const ua = navigator.userAgent.toLocaleLowerCase()
    return ua.indexOf('yach') !== -1 || ua.indexOf('zhiyinlou') !== -1
  }

  get sidebar() {
    return AppModule.sidebar
  }

  get isMobile() {
    return AppModule.device === DeviceType.Mobile
  }

  // 头像，待完善
  get avatar() {
    return UserModule.avatar || getAvatar() || ''
  }

  get username() {
    return getDisplayName()
  }

  // navbar地区名称
  get showNavbarPlaceValue() {
    return AppModule.showNavbarPlaceValue
  }

  // 是否展示navbar搜索框；
  get showNavbarSeatch() {
    return AppModule.showNavbarSeatch
  }

  // 是否展示navbar时间筛选框
  get showNavbarDateFilter() {
    return AppModule.showNavbarDateFilter
  }

  mounted() {
    this.appEnv = process.env.VUE_APP_ENV as string
    setTimeout(() => {
      this.userCurrentAppName = getuserCurrentAppName()
    }, 100)
    const now = new Date()
    const start = new Date(now.getFullYear(), now.getMonth(), 1)
    const end = now
    this.dateFilter = [this.formatDate(start), this.formatDate(end)]
    this.handleDateFilter(this.dateFilter)
    console.log('1323233223212112')
  }

  formatDate(date: Date): string {
    const yyyy = date.getFullYear()
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  // route改变时，重置navbar搜索框值；
  @Watch('$route')
  private onRouteChange(route: Route) {
    this.search = ''
    AppModule.SetNavbarSearch(this.search)
    this.dateFilter = []
    AppModule.SetNavbarDate(this.dateFilter)

    const now = new Date()
    const start = new Date(now.getFullYear(), now.getMonth(), 1)
    const end = now
    this.dateFilter = [this.formatDate(start), this.formatDate(end)]
    this.handleDateFilter(this.dateFilter)
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private handleHome() {
    this.$router.push({ path: '/' })
  }

  private async logout() {
    // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    type appIdType = '1' | '2' | '3' | '4' | '5';
    const appid: appIdType = getuserCurrentApp() as appIdType

    const LogoutMap = {
      1:
        process.env.VUE_APP_LOGOUT_API +
        '?path=' +
        process.env.VUE_APP_LOGIN_API,
      2:
        process.env.VUE_APP_LOGOUT_API +
        '?path=' +
        process.env.VUE_APP_LOGIN_API,
      3:
        process.env.VUE_APP_LOGOUT_API +
        '?path=' +
        process.env.VUE_APP_LOGIN_API,
      4:
        process.env.VUE_APP_LOGOUT_API +
        '?path=' +
        process.env.VUE_APP_LOGIN_API,
      5:
        process.env.VUE_APP_LOGOUT_API +
        '?path=' +
        process.env.VUE_APP_ADMINI_LOGIN_API
    }

    await UserModule.LogOut()

    if (appid) {
      (window as any).location = LogoutMap[appid]
    } else {
      // 知音楼退出登录
      (window as any).location = LogoutMap['1']
    }

    // // 知音楼退出登录
    // (window as any).location = process.env.VUE_APP_LOGOUT_API
  }

  // 重新选择工单类型
  private async changeTicket() {
    // 清除相关数据
    await UserModule.UserChangeTicket()
    this.$router.push({
      name: 'jumper',
      // name:'CreateIndex',
      query: { check_dash_perms: String(!isDashboardTicketType) },
      replace: true
    })
  }

  private handleSearch() {
    AppModule.SetNavbarSearch(this.search)
  }

  private handleDateFilter(date: string[]) {
    AppModule.SetNavbarDate(date)
  }
}
